import { Component } from '@angular/core';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsService } from '../../../services/websocket/WsService';
import { WsConst } from '../../../globals/WsConst';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login-method',
  templateUrl: './login-method.component.html',
  styleUrls: ['./login-method.component.css'],
})
export class LoginMethodComponent extends SuperClass {
  dashboardData: any;

  sessionsByLoginType;
  emailLoginSess;
  emailNoPassLoginByTimeSess;
  loyaltyLoginSess;
  socialMediaLoginSess;
  googleLoginByTimeSess;
  facebookLoginSess;
  twitterLoginSess;
  smsLoginSess;
  macLoginSess;
  tcLoginSess;
  paidAccessLoginByTimeSess;
  voucherLoginByTimeSess;
  sparkPieEmailNewVsRetSess;
  sparkPieEmailNoPassNewVsRetSess;
  sparkPieLoyaltyNewVsRetSess;
  sparkPieSocialMediaNewVsRetSess;
  sparkPieGoogleNewVsRetSess;
  sparkPieFacebookNewVsRetSess;
  sparkPieTwitterNewVsRetSess;
  sparkPieSMSNewVsRetSess;
  sparkPiePaidAccessNewVsRetSess;
  sparkPieVoucherNewVsRetSess;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Usage Statistics' },
      {
        label: 'Login Method',
        routerLink: [{ outlets: { sub: [RouterConst.LOGIN_METHOD] } }],
      },
    ]);
  }

  setData(data) {
    this.dashboardData = data;
    this.chartsInit();
    console.log(data);
  }

  reloadData() {
    this.dashboardDataService.getDD('LoginMethodComponent');
  }

  getWebSocketIdentifier() {
    return WsConst.STATISTICS;
  }

  chartsInit() {
    if (!this.isEmptyArray(this.dashboardData.charts.allLoginType.data1)) {
      this.sessionsByLoginType = {
        labels: [
          'Email',
          'Email No Pass',
          'Loyalty',
          'Social Media',
          'Facebook',
          'Twitter',
          'Google',
          'SMS',
          'MAC Address',
          'TC Login',
          'Paid Access',
          'Voucher',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.allLoginType.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.allLoginType.data1,
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.emailLoginByTime.data1)) {
      this.emailLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.emailLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.emailLoginByTime.data1,
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.emailNoPassLoginByTime.data1)
    ) {
      this.emailNoPassLoginByTimeSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.emailNoPassLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.emailNoPassLoginByTime.data1,
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.loyaltyLoginByTime.data1)
    ) {
      this.loyaltyLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.loyaltyLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.loyaltyLoginByTime.data1,
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.smLoginByTime.data1)) {
      this.socialMediaLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.smLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.smLoginByTime.data1,
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.googleLoginByTime.data1)) {
      this.googleLoginByTimeSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.googleLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.googleLoginByTime.data1,
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.facebookLoginByTime.data1)
    ) {
      this.facebookLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.facebookLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.facebookLoginByTime.data1,
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.twitterLoginByTime.data1)
    ) {
      this.twitterLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.twitterLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.twitterLoginByTime.data1,
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.smsLoginByTime.data1)) {
      this.smsLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.smsLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.smsLoginByTime.data1,
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.macLoginByTime.data1)) {
      this.macLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.macLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.macLoginByTime.data1,
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.tcLoginByTime.data1)) {
      this.tcLoginSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.tcLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.tcLoginByTime.data1,
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.paidAccessLoginByTime.data1)
    ) {
      this.paidAccessLoginByTimeSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.paidAccessLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.paidAccessLoginByTime.data1,
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.voucherLoginByTime.data1)
    ) {
      this.voucherLoginByTimeSess = {
        labels: [
          '0-6am',
          '6am',
          '7am',
          '8am',
          '9am',
          '10am',
          '11am',
          'Noon',
          '1pm',
          '2pm',
          '3pm',
          '4pm',
          '5pm',
          '6pm',
          '7pm',
          '8pm',
          '9pm',
          '> 10pm',
        ],
        datasets: [
          {
            label: this.dashboardData.charts.voucherLoginByTime.label1,
            backgroundColor: '#F6BD60',
            hoverBackgroundColor: '#FFE082',
            data: this.dashboardData.charts.voucherLoginByTime.data1,
          },
        ],
      };
    }

    // Pie charts

    if (
      !this.isEmptyArray(this.dashboardData.charts.sparkPieEmailNewVsRet.data)
    ) {
      this.sparkPieEmailNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieEmailNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(
        this.dashboardData.charts.sparkPieEmailNoPassNewVsRet.data,
      )
    ) {
      this.sparkPieEmailNoPassNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieEmailNoPassNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.sparkPieLoyaltyNewVsRet.data)
    ) {
      this.sparkPieLoyaltyNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieLoyaltyNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (!this.isEmptyArray(this.dashboardData.charts.sparkPieSMNewVsRet.data)) {
      this.sparkPieSocialMediaNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieSMNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.sparkPieGoogleNewVsRet.data)
    ) {
      this.sparkPieGoogleNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieGoogleNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(
        this.dashboardData.charts.sparkPieFacebookNewVsRet.data,
      )
    ) {
      this.sparkPieFacebookNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieFacebookNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.sparkPieTwitterNewVsRet.data)
    ) {
      this.sparkPieTwitterNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieTwitterNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.sparkPieSMSNewVsRet.data)
    ) {
      this.sparkPieSMSNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieSMSNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(
        this.dashboardData.charts.sparkPiePaidAccessNewVsRet.data,
      )
    ) {
      this.sparkPiePaidAccessNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPiePaidAccessNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }

    if (
      !this.isEmptyArray(this.dashboardData.charts.sparkPieVoucherNewVsRet.data)
    ) {
      this.sparkPieVoucherNewVsRetSess = {
        labels: ['New for period', 'Returning for period'],
        datasets: [
          {
            data: this.dashboardData.charts.sparkPieVoucherNewVsRet.data,
            backgroundColor: ['#F6BD60', '#488BB4'],
            hoverBackgroundColor: ['#FFE082', '#81D4FA'],
          },
        ],
      };
    }
  }

  private isEmptyArray(arr: any[]) {
    let num = 0;
    arr.forEach(el => {
      num += el;
    });
    return num === 0;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/usage_statistics/login-method/login-method.component.ts